import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { postReportHorarioStarted } from 'js/actions/reportsActions';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { showMeters } from 'js/actions/meterActions';
import { showGroups } from 'js/actions/groupActions';
import { showCharge } from 'js/actions/chargeActions';
import Swal from 'sweetalert2';
const useStyles = makeStyles(styles);

export default function HourlyReport() {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();
  const corporatives = useSelector((state) => state.corporatives.corporatives);
  const meters = useSelector((state) => state.meters.meters);
  let groups = useSelector((state) => state.groups.groups);
  let charges = useSelector((state) => state.charges.charges);
  const user = useSelector((state) => state.user.user);

  const [corporative, setCorporative] = useState();
  const [meter, setMeter] = useState();
  const [group, setGroup] = useState([]);
  const [charge, setCharge] = useState([]);
  const [year, setYear] = useState();
  const [month, setMonth] = useState();
  const [type, setType] = useState();
  const [blocking, setBlocking] = useState();

  const corpUser = user.corporative;

  const currYear = new Date().getFullYear();

  const years = [currYear - 3, currYear - 2, currYear - 1, currYear];

  useEffect(() => {
    if (user.adser != 1 && corpUser) {
      getMeters(corpUser.id);
    }
  }, []);

  const onSubmit = (values) => {
    setBlocking(true);
    dispatch(
      postReportHorarioStarted(endBlocking, values, corporative, group, charge)
    );
  };

  function endBlocking() {
    setBlocking(false);

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: 'success',
      title: 'Reporte Generado Correctamente',
    });
  }

  const getSelector = (corp) => {
    if (corp == 1) {
      return (
        <FormControl className={classes.textField}>
          <InputLabel id="demo-multiple-checkbox-label">
            {intl.formatMessage({ id: 'app.reports.hourReports.corporateLbl' })}
          </InputLabel>
          <Select
            id="demo-simple-select-outlined"
            {...register('corporative')}
            labelId="demo-simple-select-outlined-label"
            name="corporative"
            onChange={handleCorporative}
            value={corporative}
            input={
              <OutlinedInput
                label={intl.formatMessage({
                  id: 'app.reports.hourReports.corporateLbl',
                })}
              />
            }
          >
            {shortCorporatives().map((el) => (
              <MenuItem value={el.id} key={el.id}>
                {el.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    } else {
      return null;
    }
  };

  const getMeters = (corporativeId) => {
    dispatch(showMeters(corporativeId));
  };

  const getGroup = (meterId) => {
    dispatch(showGroups(meterId));
  };

  const getCharges = (groupId) => {
    dispatch(showCharge(groupId));
  };

  const handleCorporative = (corporative) => {
    setCorporative(corporative.target.value);
    setCharge([]);
    setGroup([]);
    getMeters(corporative.target.value);
  };

  const handleMeter = (meter) => {
    setMeter(meter.target.value);
    setCharge([]);
    setGroup([]);
    getGroup(meter.target.value);
  };

  const handleGroup = (group) => {
    const { value } = group.target;
    setGroup(value); // value será un array de ids seleccionados
    setCharge([]);

    // Si selecciona "TODAS", se seleccionan todos los grupos
    // Si no, se selecciona el grupo seleccionado
    if (value.includes('TODAS')) {
      setGroup(['TODAS']);
      getCharges(0);
    } else if (value.length === 1) {
      getCharges(value[0]);
    } else {
      setGroup(value);
      getCharges(0);
    }

    // Si esta seleccionado "TODAS" y seleccionan otro grupo
    // se deselecciona "TODAS" y selecciona el grupo seleccionado
    if (group.target.value.includes('TODAS') && group.target.value.length > 1) {
      setGroup(group.target.value.filter((el) => el !== 'TODAS'));
    }
  };

  const handleCharge = (chargeVal) => {
    const { value } = chargeVal.target;
    setCharge(value); // value será un array de ids seleccionados
    // Si selecciona "TODAS", se seleccionan todos los cargos
    // Si no, se selecciona el cargo seleccionado
    if (value.includes('TODAS')) {
      setCharge(['TODAS']);
    } else if (value.length === 1) {
      setCharge(value);
    } else {
      setCharge(value);
    }

    // Si esta seleccionado "TODAS" y seleccionan otro cargo
    // se deselecciona "TODAS" y selecciona el cargo seleccionado
    if (
      chargeVal.target.value.includes('TODAS') &&
      chargeVal.target.value.length > 1
    ) {
      setCharge(chargeVal.target.value.filter((el) => el !== 'TODAS'));
    }
  };

  const handleYear = (year) => {
    setYear(year.target.value);
  };

  const handleMonth = (month) => {
    setMonth(month.target.value);
  };

  const handleType = (type) => {
    setType(type.target.value);
  };

  const shortCorporatives = () => {
    const shortArray = [...corporatives];
    return shortArray.sort((a, b) =>
      a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        bgcolor: 'white',
        p: 4,
        borderRadius: 1,
        boxShadow: 1,
      }}
      width="100%"
    >
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid2 container={true} spacing={3}>
          <Grid2
            size={{ lg: 3, md: 6, xs: 6 }}
            sx={{ display: user.adser ? 'block' : 'none' }}
          >
            {getSelector(user.adser)}
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.hourReports.meterLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                {...register('meter')}
                name="meter"
                onChange={handleMeter}
                value={meter}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.hourReports.meterLbl',
                    })}
                  />
                }
              >
                {meters?.map((el) => (
                  <MenuItem value={el.id} key={el.id}>
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.hourReports.groupLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                multiple
                name="group"
                value={group}
                onChange={handleGroup}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.hourReports.groupLbl',
                    })}
                  />
                }
                renderValue={(selected) => {
                  if (!selected.length) return 'Seleccione grupos'; // Texto por defecto si no hay selección
                  return selected
                    .map((value) => {
                      if (value === 'TODAS') return 'TODAS';
                      // Si el valor es 'TODAS', no buscamos en groups
                      // Buscamos el nombre del grupo en groups
                      // y lo devolvemos
                      // Si no se encuentra, devolvemos un string vacío
                      // para evitar errores
                      // al intentar acceder a la propiedad name
                      // de un objeto undefined
                      // o null
                      const groupName = groups.find(
                        (el) => el.id === value
                      )?.name;
                      return groupName ? groupName : '';
                    })
                    .join(', ');
                }}
              >
                <MenuItem
                  value="TODAS"
                  onClick={() => handleGroup({ target: { value: 'TODAS' } })}
                >
                  <Checkbox checked={group.indexOf('TODAS') > -1} />
                  TODAS
                </MenuItem>
                {groups?.map((el) => (
                  <MenuItem key={el.id} value={el.id}>
                    <Checkbox checked={group.indexOf(el.id) > -1} />
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.hourReports.chargeLbl',
                })}
              </InputLabel>
              <Select
                {...register('charge')}
                labelId="demo-simple-select-outlined-label"
                multiple
                name="charge"
                onChange={handleCharge}
                value={charge}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.hourReports.chargeLbl',
                    })}
                  />
                }
                renderValue={(selected) => {
                  if (!selected.length) return 'Seleccione grupos'; // Texto por defecto si no hay selección
                  return selected
                    .map((value) => {
                      if (value === 'TODAS') return 'TODAS';
                      // Si el valor es 'TODAS', no buscamos en charges
                      // Buscamos el nombre del cargo en charges
                      // y lo devolvemos
                      // Si no se encuentra, devolvemos un string vacío
                      // para evitar errores
                      // al intentar acceder a la propiedad name
                      // de un objeto undefined
                      // o null
                      const chargeName = charges.find(
                        (el) => el.id === value
                      )?.name;
                      return chargeName ? chargeName : '';
                    })
                    .join(', ');
                }}
              >
                <MenuItem
                  value="TODAS"
                  onClick={() => handleCharge({ target: { value: 'TODAS' } })}
                >
                  <Checkbox checked={charge.indexOf('TODAS') > -1} />
                  TODAS
                </MenuItem>
                {charges?.map((el) => (
                  <MenuItem value={el.id} key={el.id}>
                    <Checkbox checked={charge.indexOf(el.id) > -1} />
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.hourReports.yearLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('year')}
                labelId="demo-simple-select-outlined-label"
                name="year"
                onChange={handleYear}
                value={year}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.hourReports.yearLbl',
                    })}
                  />
                }
              >
                {years?.map((yr) => (
                  <MenuItem value={yr} key={yr}>
                    {yr}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.hourReports.monthLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('month')}
                labelId="demo-simple-select-outlined-label"
                name="month"
                onChange={handleMonth}
                value={month}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.hourReports.monthLbl',
                    })}
                  />
                }
              >
                <MenuItem value="01">
                  {intl.formatMessage({ id: 'app.months.jan' })}
                </MenuItem>
                <MenuItem value="02">
                  {intl.formatMessage({ id: 'app.months.feb' })}
                </MenuItem>
                <MenuItem value="03">
                  {intl.formatMessage({ id: 'app.months.mar' })}
                </MenuItem>
                <MenuItem value="04">
                  {intl.formatMessage({ id: 'app.months.apr' })}
                </MenuItem>
                <MenuItem value="05">
                  {intl.formatMessage({ id: 'app.months.may' })}
                </MenuItem>
                <MenuItem value="06">
                  {intl.formatMessage({ id: 'app.months.jun' })}
                </MenuItem>
                <MenuItem value="07">
                  {intl.formatMessage({ id: 'app.months.jul' })}
                </MenuItem>
                <MenuItem value="08">
                  {intl.formatMessage({ id: 'app.months.ago' })}
                </MenuItem>
                <MenuItem value="09">
                  {intl.formatMessage({ id: 'app.months.sep' })}
                </MenuItem>
                <MenuItem value="10">
                  {intl.formatMessage({ id: 'app.months.oct' })}
                </MenuItem>
                <MenuItem value="11">
                  {intl.formatMessage({ id: 'app.months.nov' })}
                </MenuItem>
                <MenuItem value="12">
                  {intl.formatMessage({ id: 'app.months.dec' })}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid2>
          <Grid2
            size={{ lg: 3, md: user.adser ? 12 : 6, xs: user.adser ? 12 : 6 }}
          >
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.hourReports.reportTypeLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('type')}
                labelId="demo-simple-select-outlined-label"
                name="type"
                onChange={handleType}
                value={type}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.hourReports.reportTypeLbl',
                    })}
                  />
                }
              >
                <MenuItem value="CONSUME">
                  {intl.formatMessage({
                    id: 'app.reports.hourReports.reportType.consumpt',
                  })}
                </MenuItem>
                <MenuItem value="DEMAND">
                  {intl.formatMessage({
                    id: 'app.reports.hourReports.reportType.demand',
                  })}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid2>
          <Button
            className={classes.signUpButton}
            color="primary"
            size="large"
            type="submit"
            loading={blocking}
            variant="contained"
            loadingPosition="start"
          >
            {blocking
              ? 'Cargando...'
              : intl.formatMessage({
                  id: 'app.reports.hourReports.uploadBtn',
                })}
          </Button>
        </Grid2>
      </form>
    </Box>
  );
}
